import * as React from "react";
import Component from "src/components/Component";
import withAxios, { IAxiosProps } from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import IDirectorPageProps from "../IDirectorPageProps";
import Page from "src/components/Page";
import EvaluationPrinter, { PrintEvaluationFunc } from "../evaluation/EvaluationPrinter";
import DashboardGenerateReportModal from "../dashboard/reportGeneratemodal";
import EvaluationGenerateReportModal from "../evaluation/reportGeneratemodal";
import VideoModal from "src/components/videoModal";
import "./report-history.css";
import { FILE_URL } from "src/constants";




interface IReport {
  id: number | string;
  chatgptChangeResposne: Record<string, any>;
  [key: string]: any;
}

// Extend props to include schoolData and editableReportData
interface IReportHistoryProps extends IAxiosProps, IDirectorPageProps {
  schoolData: {
    ismidseason: boolean;
    name?: string;
    logo1?: string;
    primaryColor?: string;
    [key: string]: any;
  };
  refreshReports: () => void;
  editableReportData: IReport[];
}

interface IState {
  loading: boolean;
  error?: string;
  viewMode: "school" | "coach";
  activeModalType?: "school" | "coach";
  sportId: string;
  coachId: string;
  type: string;
  year: string;
  season: string;
  data: any;
  coachList: any[];
  coachListLoading: boolean;
  showPrintButton?: boolean;
  reportGenerateModalVisible?: boolean;
  validationErrors: {
    viewMode?: string;
    season?: string;
    coach?: string;
    year?: string;
    data?: string;
  };
  showVideo: boolean;
  videoURL: string;
  openSchoolPopup: boolean;
  openCoachPopup: boolean;
  selectedSurveyId?: number;
  editableReportData: IReport[];
  coachIds: any[]; // For single coach selection in this flow
  selectedCoachSportId: string;
  dropdownOpen: boolean;
}


// Exact request payload shape for /reports/reportGetAllData
interface IReportGetAllDataRequest {
  schoolId: number;           // e.g., 91
  sessionType: string;        // e.g., "FALL"
  coachId: number;            // e.g., 1133
  sportId?: number;           // e.g., 35
  type: "coach";             // literal value "coach"
  year: string;               // e.g., "2023"
}

export default withSchoolContext(
  withAxios(
    class ReportHistory extends Component<IReportHistoryProps & IAxiosProps & IDirectorPageProps, IState> {
      public readonly state = this.buildState({
        loading: false,
        viewMode: "school",
        activeModalType: undefined,
        year: String(new Date().getFullYear()),
        type: "",
        sportId: "",
        coachId: "",
        season: "",
        data: null,
        coachList: [],
        coachListLoading: false,
        validationErrors: {},
        showVideo: false,
        videoURL: "",
        openSchoolPopup: false,
        openCoachPopup: false,
        selectedSurveyId: undefined,
        editableReportData: [],
        coachIds: [],
        selectedCoachSportId: "",
        dropdownOpen: false
      });

      private printEvaluation?: PrintEvaluationFunc;

      public readonly setPrintEvaluation = (
        printEvaluation: PrintEvaluationFunc | null
      ) => {
        this.printEvaluation = printEvaluation === null ? undefined : printEvaluation;
        this.setState({ showPrintButton: !!this.printEvaluation });
      };
      public readonly handleVideoClick = (videoURL: string) => {
        this.setState({ showVideo: true, videoURL });
      };

      public readonly handleSchoolViewPrintClick = async () => {
        const { year, season } = this.state;
        const validationErrors: { year?: string; season?: string } = {};

        if (!year) {
          validationErrors.year = "Please select a year";
        }

        if (!season) {
          validationErrors.season = "Please select a season";
        }

        if (Object.keys(validationErrors).length > 0) {
          this.setState({ validationErrors });
          return;
        }

        this.setState({ openSchoolPopup: true });
        try {
          this.setState({ loading: true, error: undefined });
          const schoolId = Number(this.props.school?.id);
          if (!schoolId) {
            this.setState({ loading: false, error: "Invalid school id" });
            return;
          }

          const payload = {
            schoolId,
            sportId: -1,
            coachId: -1,
            type: "ad",
            sessionType: this.state.season,
            year: this.state.year,
          } as const;

          const response: any = await this.buildPost<any, any>(this, "/reports/reportGetAll")(payload);
          const rawData = response?.data;
          console.log("school view print response", response);
          console.log("rawData:", rawData);
          console.log("rawData type:", typeof rawData);
          console.log("rawData isArray:", Array.isArray(rawData));

          const hasData = !!rawData && (
            (Array.isArray(rawData) && rawData.length > 0) ||
            (!Array.isArray(rawData) && Object.keys(rawData).length > 0)
          );

          if (hasData) {
            // Normalize to array for editing/rendering convenience
            const normalizedArray = Array.isArray(rawData)
              ? rawData
              : (rawData?.data && Array.isArray(rawData.data))
                ? rawData.data
                : [rawData];
            console.log("normalizedArray:", normalizedArray);
            console.log("normalizedArray length:", normalizedArray.length);
            this.setState({
              data: rawData,
              editableReportData: normalizedArray,
              loading: false,
              reportGenerateModalVisible: true,
              activeModalType: "school",
              error: undefined,
            });
          } else {
            this.setState({
              data: [],
              editableReportData: [],
              loading: false,
              reportGenerateModalVisible: false,
              activeModalType: undefined,
              error: "No report data available for the selected year and season.",
            });
          }
        } catch (err: any) {
          this.setState({ loading: false, error: err?.message || "Failed to load school reports" });
        }
      };

      public readonly handlePrintClick = async (coachIdParam?: string | number) => {
        try {
          const { season, year, selectedCoachSportId } = this.state;

          const coachId = coachIdParam ?? this.state.coachIds[0] ?? this.state.coachId;

          // Clear previous validation errors
          this.setState({ validationErrors: {} });

          // Validation
          if (!season || season.trim() === "") {
            this.setState({ validationErrors: { season: "Please select a season first" } });
            return;
          }
          if (!coachId || String(coachId).trim() === "") {
            this.setState({ validationErrors: { coach: "Please select a coach first" } });
            return;
          }
          if (!year || year.trim() === "") {
            this.setState({ validationErrors: { year: "Please select a year first" } });
            return;
          }

          const coachIdNum = Number(coachId);
          const selectedCoachFromList = (this.state.coachList as Array<{ id: number; sports?: Array<{ id: number; name: string }> }>).find(
            (coach) => String(coach.id) === String(coachIdNum)
          );
          const coachSports = selectedCoachFromList?.sports || [];
          const resolvedSelectedSportId = selectedCoachSportId
            ? Number(selectedCoachSportId)
            : coachSports.length === 1
              ? Number(coachSports[0].id)
              : undefined;

          // Load the latest coach history rows before opening the coach report modal.
          const reportRows = await this.fetchReportsCoach(coachIdNum, false, resolvedSelectedSportId);

          if (!reportRows.length) {
            this.setState({
              data: [],
              editableReportData: [],
              reportGenerateModalVisible: false,
              activeModalType: undefined,
              error: "No report data available for this coach, season, and sport.",
              loading: false,
            });
            return;
          }

          const selectedReportRow = this.pickCoachHistoryReportRow(reportRows, resolvedSelectedSportId);
          const surveyId = Array.isArray(selectedReportRow?.surveyId)
            ? selectedReportRow.surveyId[0]
            : selectedReportRow?.surveyId || selectedReportRow?.survey_id;
          const sportId = Array.isArray(selectedReportRow?.sportId)
            ? selectedReportRow.sportId[0]
            : selectedReportRow?.sportId;

          if (!surveyId || !sportId) {
            alert("Required coach report data is missing.");
            return;
          }

          const finalSportId = resolvedSelectedSportId && Number.isFinite(resolvedSelectedSportId)
            ? resolvedSelectedSportId
            : Number(sportId);

          this.setState({
            coachId: String(coachIdNum),
            sportId: String(finalSportId),
            selectedSurveyId: Number(surveyId),
            data: [selectedReportRow],
            editableReportData: [selectedReportRow],
            reportGenerateModalVisible: true,
            activeModalType: "coach",
          });
        } catch (err) {
          console.error("Print evaluation failed:", err);
        }
      };


      public handleCoachCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        return;
      };

      public componentDidMount() {
        // this.fetchCoachList();
        // Automatically check and play video when page loads
        this.checkAndPlayVideo();
      }



      public render() {
        const { loading, error, data, year, coachId, season, viewMode, activeModalType, coachList, coachListLoading, reportGenerateModalVisible, selectedCoachSportId } = this.state;
        const { coaches, seasons, school } = this.props as any;
        // Use fetched coach list for coach mode, fallback to props coaches
        const availableCoaches = viewMode === "coach" ? coachList : coaches;
        const selectedCoachId = this.state.coachIds[0] || coachId;
        const selectedCoach = Array.isArray(coachList)
          ? (coachList as Array<{ id: number; name: string; sports?: Array<{ id: number; name: string }> }>).find(
              (c: { id: number; name: string; sports?: Array<{ id: number; name: string }> }) => String(c.id) === String(selectedCoachId)
            )
          : undefined;
        const selectedCoachSports: Array<{ id: number; name: string }> = selectedCoach && Array.isArray(selectedCoach.sports)
          ? selectedCoach.sports
          : [];
        const resolvedSelectedCoachSportId = selectedCoachSportId || (selectedCoachSports.length === 1 ? String(selectedCoachSports[0].id) : "");
        const reportArray = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);

        return (
          <Page header={"Report History"} subtitle={"Filter and view previous reports"}>
            <EvaluationPrinter printEvaluationRef={this.setPrintEvaluation} />
            <div className="report-history-outer-container">
              <div className="report-history-inner-container">
                {/* View mode selector */}
                <div>
                  <select className="select-style"
                    value={viewMode}
                    onChange={(e) => this.setState({ viewMode: e.target.value as any, validationErrors: {} })}

                  >
                    <option value="school">By School</option>
                    <option value="coach">By Coach</option>
                  </select>
                  {this.state.validationErrors.viewMode && (
                    <div className="error">
                      {this.state.validationErrors.viewMode}
                    </div>
                  )}
                </div>

                {/* Year for school mode; Season for coach mode */}
                {viewMode === "school" ? (
                  <>
                    <div>
                      <select className="select-style"
                        value={year}
                        onChange={(e) => this.setState({ year: e.target.value, validationErrors: {} })}

                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Year
                        </option>
                        {Array.from({ length: 4 }).map((_, i) => {
                          const y = String(new Date().getFullYear() - i);
                          return (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          );
                        })}
                      </select>
                     
                      {this.state.validationErrors.year && (
                        <div className="error">
                          {this.state.validationErrors.year}
                        </div>
                      )}
                    </div>

                    <div>
                      <select className="select-style"
                        value={season}
                        onChange={(e) => this.setState({ season: e.target.value, coachId: "", coachIds: [], selectedCoachSportId: "", validationErrors: {} }, this.fetchCoachList)}

                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Season
                        </option>
                        {seasons.map((s: { name: string }) => (
                          <option key={s.name} value={s.name}>
                            {s.name}
                          </option>
                        ))}
                      </select>
                      {this.state.validationErrors.season && (
                        <div className="error">
                          {this.state.validationErrors.season}
                        </div>
                      )}
                    </div>

                    {/* Show selected Year + Season summary under selects */}

                    <div>
                      <button
                        className="upgrade-subscription-btn"
                        onClick={this.handleSchoolViewPrintClick}
                        disabled={loading}

                        title="View & Print by School"
                      >
                        <span>{loading ? "Loading..." : "View & Print"}</span>
                      </button>
                    </div>

                  </>
                ) : (
                  <div>
                    <select className="select-style"
                      value={season}
                        onChange={(e) => this.setState({ season: e.target.value, coachId: "", coachIds: [], selectedCoachSportId: "", validationErrors: {} }, this.fetchCoachList)}
                    >
                      <option value="" disabled={true} hidden={true}>
                        Select Season
                      </option>
                      {seasons.map((s: { name: string }) => (
                        <option key={s.name} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                    {this.state.validationErrors.season && (
                      <div className="error">
                        {this.state.validationErrors.season}
                      </div>
                    )}
                  </div>
                )}


                {/* Coach for coach mode */}
                {viewMode === "coach" ? (
                  <>
                    <div>
                      <select className="select-style"
                        value={year}
                        onChange={(e) => this.setState({ year: e.target.value, coachId: "", coachIds: [], selectedCoachSportId: "", validationErrors: {} }, this.fetchCoachList)}
                      // onChange={(e) => this.setState({ coachId: e.target.value, validationErrors: {} }, this.fetchCoachList)}
                      // coachIds: []
                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Year
                        </option>
                        {Array.from({ length: 4 }).map((_, i) => {
                          const y = String(new Date().getFullYear() - i);
                          return (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          );
                        })}
                      </select>

                      {this.state.validationErrors.year && (
                        <div className="error">
                          {this.state.validationErrors.year}
                        </div>
                      )}
                    </div>
                    

                    <div className="select-coach-outer">
                      <select
                        className="select-style"
                        value={selectedCoachId || ""}
                        disabled={coachListLoading}
                        onChange={(e) => {
                          const nextCoachId = e.target.value;
                          const nextCoach = (coachList as Array<{ id: number; name: string; sports?: Array<{ id: number; name: string }> }>).find(
                            (coach) => String(coach.id) === String(nextCoachId)
                          );
                          const nextCoachSports = nextCoach?.sports || [];
                          const autoSportId = nextCoachSports.length === 1 ? String(nextCoachSports[0].id) : "";

                          this.setState({
                            coachId: nextCoachId || "",
                            coachIds: nextCoachId ? [nextCoachId] : [],
                            selectedCoachSportId: autoSportId,
                            validationErrors: {},
                          });
                        }}
                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Coach
                        </option>
                        {(availableCoaches as Array<{ id: number; name: string; sports?: Array<{ id: number; name: string }> }>).map(
                          (coach) => (
                            <option key={coach.id} value={String(coach.id)}>
                              {coach.name}
                            </option>
                          )
                        )}
                      </select>

                      {/* Error */}
                      {this.state.validationErrors.coach && (
                        <div style={{ color: "red", marginTop: "4px", fontSize: "12px" }}>
                          {this.state.validationErrors.coach}
                        </div>
                      )}
                    </div>

                    {selectedCoach && selectedCoachSports.length > 0 && (
                      <div className="report-history-sport-select">
                        <select
                          className="select-style"
                          value={resolvedSelectedCoachSportId}
                          onChange={(e) => this.setState({ selectedCoachSportId: e.target.value, validationErrors: {} })}
                        >
                          <option value="" disabled={true} hidden={true}>
                            Select Sport
                          </option>
                          {selectedCoachSports.map((sport: { id: number; name: string }) => (
                            <option key={sport.id} value={String(sport.id)}>
                              {sport.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <button
                      className="upgrade-subscription-btn"
                      onClick={async () => {
                        const { coachIds } = this.state;
                        const effectiveSportId = selectedCoachSportId || (selectedCoachSports.length === 1 ? String(selectedCoachSports[0].id) : "");
                        console.log("Selected coachIds for printing:", coachIds, "selectedCoachSportId:", effectiveSportId);

                        if (!coachIds || coachIds.length === 0) {
                          alert("Select at least one coach first");
                          return;
                        }

                        if (selectedCoach && selectedCoachSports.length > 1 && !effectiveSportId) {
                          alert("Select a sport for the chosen coach first");
                          return;
                        }

                        // History modal supports one coach preview at a time.
                        await this.handlePrintClick(coachIds[0]);
                      }}
                      disabled={this.state.loading}
                      title={
                        !this.state.coachIds || this.state.coachIds.length === 0
                          ? "Select at least one coach first"
                          : (!this.state.data || this.state.data.length === 0)
                            ? "No report data available"
                            : "Print report"
                      }
                    >
                      <span>View & Print</span>
                    </button>




                  </>
                ) :

                  (
                    <div />
                  )}






                <div>

                  {this.state.validationErrors.data && (
                    <div className="error">
                      {this.state.validationErrors.data}
                    </div>
                  )}
                </div>







              </div>



              {error && <div style={{ color: "#b00020" }}>{error}</div>}


            </div>

            {(() => {
              console.log("Modal render check:", { reportGenerateModalVisible, selectedCoach, reportArray, data });
              console.log("reportArray length:", reportArray?.length);
              console.log("data structure:", data);
              if (!reportGenerateModalVisible) {
                return null;
              }

              if (activeModalType === "coach") {
                const selectedReport = reportArray?.[0] || {};
                const activeCoachId = Number(this.state.coachId || this.state.coachIds[0] || 0);
                const activeSportId = Number(
                  this.state.sportId ||
                    this.state.selectedCoachSportId ||
                    (Array.isArray(reportArray?.[0]?.sportId)
                      ? reportArray[0].sportId[0]
                      : reportArray?.[0]?.sportId || 0)
                );
                const activeSurveyId = Number(
                  this.state.selectedSurveyId ||
                    (Array.isArray(reportArray?.[0]?.surveyId)
                      ? reportArray[0].surveyId[0]
                      : reportArray?.[0]?.surveyId || 0)
                );
                const activeCoach =
                  (availableCoaches as Array<{ id: number; name: string }>).find(
                    (coachRow) => Number(coachRow.id) === activeCoachId
                  ) || { id: activeCoachId, name: "" };
                const reportYear = Number(selectedReport?.year || this.state.year);
                const reportDate = Number.isFinite(reportYear)
                  ? new Date(reportYear, 0, 1).getTime()
                  : selectedReport?.date
                    ? new Date(selectedReport.date).getTime()
                    : Date.now();

                // Report history reuses the evaluation coach modal in print-only mode.
                const coachModalProps: any = {
                  ReportData: reportArray,
                  schoolData: school,
                  startDate: reportDate,
                  endDate: reportDate,
                  sport: {
                    id: activeSportId,
                    name: selectedReport?.sportName || selectedReport?.sport?.name || "",
                  } as any,
                  coach: activeCoach as any,
                  surveyId: activeSurveyId,
                  schoolId: Number(school?.id),
                  slug: school?.slug || "",
                  open: true,
                  closeModal: () =>
                    this.setState({
                      reportGenerateModalVisible: false,
                      activeModalType: undefined,
                    }),
                  refreshReports: async () => {
                    await this.fetchReportsCoach(activeCoachId, false);
                  },
                  showLoaderStudent: false,
                  showLoaderParent: false,
                  editButtonLoading: false,
                  reportLoading: loading,
                  isCoachSelfAssessmentOnly: false,
                  isChampions101Survey: false,
                  readOnly: true,
                  key: `coach-modal-${activeCoachId}-${activeSurveyId}-${reportArray?.length || 0}`,
                };

                return (
                  <EvaluationGenerateReportModal {...coachModalProps} />
                );
              }

              // Keep the existing seasonal/school history modal unchanged for school reports.
        const schoolModalProps: any = {
          open: true,
          closeModal: () =>
            this.setState({
              reportGenerateModalVisible: false,
              activeModalType: undefined,
            }),
          ReportData: reportArray,
          schoolData: school,
          schoolId: school?.id,
          slug: school?.slug,
          // Report history should not expose generation inside the school preview.
          hideGenerateReportButton: true,
          refreshReports: this.fetchReports,
          key: `school-modal-${reportArray?.length || 0}`,
        };

              return (
                <DashboardGenerateReportModal {...schoolModalProps} />
              );
            })()}


            {/* Video Modal */}
            <VideoModal
              videoURL={FILE_URL + "/" + this.state.videoURL}
              // videoURL={this.state.videoURL}
              open={this.state.showVideo}
              handleClose={async () => {
                this.setState({ showVideo: false });
                // Report video watched when modal is closed
                try {
                  const userResponse: any = await this.buildGet<any>(this, "user")();
                  const userId = String(userResponse?.data?.id || userResponse?.id || "1");
                  const schoolId = String(this.props.school?.id || "1");
                  await this.reportVideoWatched(userId, schoolId);
                } catch (err) {
                  console.error("Error getting user ID for video report:", err);
                }
              }}
            />
          </Page>

        );
      }

      private readonly fetchReportsCoach = async (
        coachIdNum: number,
        shouldStoreRows = true,
        selectedSportId?: number
      ) => {
        this.setState({ loading: true, error: undefined });
        console.log("Fetching reports with state:", this.state);
        console.log("Fetching reports with props:", this.props);
      
        try {
          const selectedCoachFromList = (this.state.coachList as Array<{ id: number; sports?: Array<{ id: number; name: string }> }>).find(
            (coach) => String(coach.id) === String(coachIdNum)
          );
          const coachSports = selectedCoachFromList?.sports || [];
          const resolvedSportId = selectedSportId
            ? Number(selectedSportId)
            : this.state.selectedCoachSportId
              ? Number(this.state.selectedCoachSportId)
              : coachSports.length === 1
                ? Number(coachSports[0].id)
                : -1;

          const payload: IReportGetAllDataRequest = {
            schoolId: Number(this.props.school.id),
            sessionType: String(this.state.season || ""),
            coachId: coachIdNum,
            sportId: resolvedSportId,
            type: "coach",
            year: String(this.state.year),
          };
      
          const ReportData: any = await this.buildPost<
            IReportGetAllDataRequest,
            any
          >(this, "/reports/reportGetAllData")(payload);

          const normalizedRows = Array.isArray(ReportData?.data)
            ? ReportData.data
            : Array.isArray(ReportData)
              ? ReportData
              : [];

          if (shouldStoreRows) {
            this.setState({
              data: normalizedRows,
              editableReportData: normalizedRows,
              loading: false,
            });
          } else {
            this.setState({ loading: false });
          }
          return normalizedRows;
        } catch (err: any) {
          this.setState({ error: err?.message || "Failed to load reports", loading: false });
          return [];
        }
      };


      private readonly pickCoachHistoryReportRow = (reportRows: any[], selectedSportId?: number) => {
        if (selectedSportId) {
          const sportMatch = reportRows.find((row) => {
            const rowSportId = Array.isArray(row?.sportId)
              ? row.sportId[0]
              : row?.sportId;
            return Number(rowSportId) === Number(selectedSportId);
          });

          if (sportMatch) {
            return sportMatch;
          }
        }

        // Report history should open the exact latest row returned for the selected
        // coach/season/year. Old-vs-new rendering is already handled inside the
        // evaluation modal after reading this row's payload shape.
        return reportRows[0];
      };
      

      private readonly fetchReports = async () => {
        this.setState({ loading: true, error: undefined });
        console.log("Fetching reports with state:", this.state);
        console.log("Fetching reports with props:", this.props);

        try {
          const coachIdNum = Number(this.state.coachId || this.state.coachIds[0] || 0);
          const selectedCoachFromList = (this.state.coachList as Array<{ id: number; sports?: Array<{ id: number; name: string }> }>).find(
            (coach) => String(coach.id) === String(coachIdNum)
          );
          const coachSports = selectedCoachFromList?.sports || [];
          const resolvedSportId = this.state.selectedCoachSportId
            ? Number(this.state.selectedCoachSportId)
            : coachSports.length === 1
              ? Number(coachSports[0].id)
              : -1;

          const payload: IReportGetAllDataRequest = {
            schoolId: Number(this.props.school.id),
            sessionType: String(this.state.season || ""),
            coachId: coachIdNum,
            sportId: resolvedSportId,
            type: "coach",
            year: String(this.state.year),
          };

          const ReportData: any = await this.buildPost<
            IReportGetAllDataRequest,
            any
          >(this, "/reports/reportGetAllData")(payload);

          this.setState({ data: ReportData?.data ?? ReportData, loading: false });
        } catch (err: any) {
          this.setState({ error: err?.message || "Failed to load reports", loading: false });
        }
      };

      private readonly fetchCoachList = async () => {
        this.setState({ coachListLoading: true });
        try {
          const sessionType = this.state.season ? encodeURIComponent(this.state.season) : "";
          const coachListUrl = sessionType
            ? `/report/coachlist/${this.props.school.id}?sessionType=${sessionType}&year=${this.state.year}`
            : `/report/coachlist/${this.props.school.id}`;
          const response = await this.buildGet<any>(this, coachListUrl)();
          this.setState({
            coachList: response?.data || response || [],
            coachListLoading: false
          });
        } catch (err: any) {
          console.error("Failed to fetch coach list:", err);
          this.setState({
            coachList: [],
            coachListLoading: false
          });
        }
      };

      private readonly checkAndPlayVideo = async () => {
        try {
          const { school } = this.props;
          // Get actual user ID from API
          const userResponse: any = await this.buildGet<any>(this, "user")();
          const userId = String(userResponse?.data?.id || userResponse?.id || "1");

          const schoolId = String(school?.id); // Get actual school ID from props

          console.log("Using userId:", userId, "and schoolId:", schoolId);

          // Check if video should be shown via API
          // const videoCheckResponse = await this.buildGet<any>(this, `/report/getVideo/${userId}/${schoolId}`)();
          const videoCheckResponse = await this.buildGet<any>(this, `/report/getVideo/${schoolId}/${userId}`)();

          console.log("Video check response:", videoCheckResponse);

          if (videoCheckResponse.status === true) {
            console.log("testing purpose", videoCheckResponse.status)
          }
          if (videoCheckResponse.status === true || videoCheckResponse?.data.status === true) {
            console.log("Video should be shown, opening video modal", videoCheckResponse.status);


            // Get the actual video URL using the video ID from response
            const videoId = 5;
            await this.getVideoURL(videoId);

            // After video is shown, call the report API
            // await this.reportVideoWatched(userId, schoolId);
          } else {
            console.log("Video should not be shown");
          }
        } catch (err) {
          console.error("Error checking for video :", err);
        }
      };

      private readonly reportVideoWatched = async (userId: string, schoolId: string) => {
        try {
          const payload = {
            userId,
            schoolId
          };

          const response = await this.buildPost<any, any>(this, "/report/reportVideoCreate")(payload);
          console.log("Video watched reported successfully:", response);
        } catch (err) {
          console.error("Error reporting video watched:", err);
        }
      };

      private readonly getVideoURL = async (videoId: any) => {
        try {
          const res: any = await this.buildGet(this, "video/getOneVideo/" + videoId)();

          console.log("Video response:", res);

          if (res?.data?.file) {
            const videoURL = res.data.file;
            this.setState({ showVideo: true, videoURL });
            console.log("Video URL set:", videoURL);
          } else {
            console.log("No video file found in response");
          }
        } catch (err) {
          console.error("Error getting video URL:", err);
        }
      };
    }
  )
);




// WEBPACK FOOTER //
// ./src/pages/director/reportHistory/index.tsx